import { Validator } from '@vista-digital/validator';
import { EventImageMediaType } from './media-type';
/**
 * Default configuration options for the Event Image component.
 */
export const defaultEventImageConfig = {
    mediaType: EventImageMediaType.Poster
};
export const eventImageConfigValidatorSchema = {
    mediaType: Validator.oneOf(Object.values(EventImageMediaType))
};
export const eventImageConfigValidator = Validator.object(eventImageConfigValidatorSchema);
